import { LiveKItJoinHandlerInterface } from "@share/live-kit/interfaces/LiveKItJoinHandlerInterface";
import { RoomState } from "livekit-client";

export class ReconnectingController {
    isReconnecting = false;
    private timerId: NodeJS.Timeout | null = null;

    constructor(
        private readonly joinHandler: LiveKItJoinHandlerInterface
    ) {}

    startReconnecting() {
        this.isReconnecting = true;
    }

    stopReconnecting(state: RoomState) {
        if (!this.isReconnecting) {
            return;
        }

        this.isReconnecting = false;

        if(state == RoomState.Disconnected) {
            this.joinHandler.cantJoin = true;
        }
    }

}